import { Directive, Input, ViewContainerRef, TemplateRef} from '@angular/core';

@Directive({
  selector: '[appTask]'
})
export class TaskDirective {

    taskPermissionList: any[];


    constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {

    }

    @Input() set appTask(taskPermission: number) {

        this.taskPermissionList = JSON.parse(localStorage.getItem('taskPermissionList'))

        if (this.taskPermissionList?.some(value => value === taskPermission)) {
            this.viewContainer.createEmbeddedView(this.templateRef)
        }else{
            this.viewContainer.clear()
        }
    }
}
